import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/webapp';

export const logAsDelivered = async (data) => {
  await ajax('POST', `${rootUrl}/set-multi-log`, JSON.stringify(data));
};

export const logUserAction = async (data) => {
  await ajax('POST', `${rootUrl}/log-activity`, JSON.stringify(data));
};
